module.exports = __webpack_public_path__ + "img/shop-bg-default.a814f2db.webp";